/* eslint-disable promise/always-return */
/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
import React, { useState } from 'react'
import { Modal, PrimaryButton, Text } from '..'
import { IconButton } from '@material-ui/core'
import { colors } from '../../Themes'
import ClearIcon from '@material-ui/icons/Clear'
import { PlanChange, tick } from '../../Themes/Images'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import StepBeforeDowngradeModalStyle from './StepBeforeDowngradeModal.styles'
import { useAuth } from '../../Global'
import { Axios } from '../../Config'
import { SecondaryOutlinedButton3, SecondaryOutlinedButton4 } from '../Button/Button'

const LOCK_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: tick,
  rendererSettings: {
    className: 'loginAnim',
  },
}

function StepBeforeDowngradeModal({ isVisible, cancel, plan }) {
  const classes = StepBeforeDowngradeModalStyle()
  const { getUpdatedUser } = useAuth()
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  const redirectToCancelPlan = () => {
    history.push('/cancelPlan' )
  }

  const onSubmit= async ()=>{
    redirectToCancelPlan()
    // setLoading(true)
  //   try {
  //     await Axios.post('/prod/user/setupfreeaccount',
  //     )
  //     await getUpdatedUser()
  //     setLoading(false)
  //     redirectToInfo()
  //   //   showModal()
  //   } catch (error) {
  //     setLoading(false)
  //   }
  }

  const onCancel = () => {
    cancel()
  }
  
  return (
    <Modal type="noBlur" costumizedPaperStyles={classes.paperCostum} opened={isVisible}>
      <div className={classes.ModalWrapper}>
        <IconButton
          disableFocusRipple
          centerRipple={true}
          disableRipple={true}
          style={{ backgroundColor: 'transparent' }}
          classes={{ root: classes.iconButtonClose }}
          onClick={() => onCancel()}
        >
          <ClearIcon classes={{ root: classes.closeIcon }} />
        </IconButton>
        
      
        <div className={classes.text2}>
          <Text size='h3' color={colors.accent} weight='bold'>Cancel subscription</Text>
        </div>
        <div className={classes.border} />
        <div className={classes.text3}>
          <PlanChange />
        </div>
        <div className={classes.text4}>
          <Text size='subnote' color={colors.primary}>Are you sure you want to cancel your subscription and pass to the Free plan?</Text>
        </div>
        <div className={classes.text2}>
          <Text size='small' color={colors.primary}>All your add-ons will be removed.</Text>
        </div>
        <div className={classes.border2} />
        <div className={classes.buttonsWrapper}>
          <SecondaryOutlinedButton4
            className={classes.button}
            onClick={() => cancel()}
            style={{ border: '1px solid #cccccc' }}
          > Cancel
          </SecondaryOutlinedButton4>
          <SecondaryOutlinedButton3
            className={classes.secondButton}
            // disabled={isDisabled || isLoading}
            loading={loading}
            style={{
              backgroundColor: loading ? colors.disabled : colors.primary,
              color: colors.white,
              borderColor: loading ? colors.disabled : colors.primary
            }}
            onClick={() => onSubmit()}
          >
            Continue
          </SecondaryOutlinedButton3>
        </div>
      </div>
    </Modal>
  )
}

export default StepBeforeDowngradeModal  
